

























































import { Component, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import GenericAdd from "../../core/Generics/GenericAdd";
import Porposal from "@/models/porposal/porposal.model";
import { PorposalModality } from "@/enums/PorposalModality";
import CoinService from "@/services/coins.service";
import { PorposalExpectedResult } from "@/enums/PorposalExpectedResult";
import ProposalMember from "../../models/porposal/porposalMembers.model";
import ProposalDocument from "@/models/porposal/proposalDocument.Model";
import MemberTypeService from "@/services/memberType.service";
import ProjectTypeService from "@/services/projectType.service";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import GenericEdit from "../../core/Generics/GenericEdit";
import Document from "../../models/document.model";
import ProposedConsortium from "@/models/porposal/proposedConsortium.Model";
import moment from "moment";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import PorposalBudgetItem from "@/models/porposal/porposalBudgetItem.model";
import BudgetExpenseService from "@/services/budgetExpense.service";
import { BudgetItemCalculation } from "@/enums/BudgetItemCalculation";
import { Utils } from "@/core/Utils";
import AnnoucementAreasService from "@/services/AnnoumentArea.service";
import ResearchCenterService from "@/services/researchCenter.service";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import DocumentComponentViewer from "@/components/document-component-view/documentComponentViewer.vue";
import UserService from "@/services/user.service";
//import PorposalDetail from '@/components/porposal-detail-component/detail.vue'
import PorposalDetail from '@/components/porposal-detail-component/detail-optimized.vue'
import AnnoucementService from '@/services/Annoument.service';

@Component({
  components: {
    DatePickerComponent,
    documentcomponent: DocumentComponent,
    ResearchCenterBasicInformationComponent,
    UserBasicInformationComponent,
    DocumentComponentViewer,
    PorposalDetail
  }
})
export default class PorposalConfirmation extends GenericEdit<Porposal> {
  currentTab = 1;
  memberTypes: any = [];
  projectTypes: any = [];
  researchCenters = [];
  PorposalModality = PorposalModality;
  PorposalExpectedResult = PorposalExpectedResult;
  CoinService = new CoinService();
  memberTypeService: MemberTypeService = new MemberTypeService();
  projectTypeService: ProjectTypeService = new ProjectTypeService();

  annoucementAreasService: AnnoucementAreasService = new AnnoucementAreasService();
  researchCenterService: ResearchCenterService = new ResearchCenterService();
  annoucementService: AnnoucementService = new AnnoucementService();

  userService: UserService = new UserService();
  counter: number;
  words: any;
  loading = false;
  dropFiles = [];
  Status: Boolean;
  Coins: [];
  annoucementId: number | null = null;
annoucementTitle = "";
  years: Array<number> = [];
  budgetExpenses = [];
  budgetItemCurrent = new PorposalBudgetItem();
  showAddPartida = false;
  budgetExpenseService = new BudgetExpenseService();
  BudgetItemCalculation = BudgetItemCalculation;

  totalBudgetFondocyt: number = 0;
  totalBudgetInstitutionalAport: number = 0;
  showWarning = false;
  areas: any = [];
  fieldAreas: any = [];
  fieldAreasResearchLines: any = [];
  researchCenter: any = null;

  constructor() {
    super();
    this.controller = "Porposal";
    this.model = new Porposal();
    this.Coins = [];
    this.counter = 0;
    this.words = "";
    this.Status = false;
    Quill.register("modules/imageDrop", ImageDrop);
  }

  onSelectDoc(selected: any) {
    if (this.model.proposalDocuments) {
      if (
        selected.documentId &&
        this.model.proposalDocuments.some(
          y => y.documentId === selected.documentId
        )
      ) {
        let index = this.model.proposalDocuments.findIndex(
          y => y.documentId === selected.documentId
        );
        this.model.proposalDocuments[index].deleted = false;
      } else if (
        this.model.proposalDocuments.some(
          y => y.document && y.document.contentTypeId === selected.contentTypeId
        )
      ) {
        let index = this.model.proposalDocuments.findIndex(
          y => y.document && y.document.contentTypeId === selected.contentTypeId
        );
        let doc = this.model.proposalDocuments[index];
        doc.documentId = selected.documentId;
        doc.document = selected.document || selected;
        this.model.proposalDocuments.splice(index, 1, doc);
      } else {
        let doc = new ProposalDocument();
        doc.documentId = selected.documentId;
        doc.document = selected.document;
        this.model.proposalDocuments.push(doc);
      }
    }
  }
   @Watch("annoucementId")
  getEvaluators() {
    
    this.annoucementService
      .getDetailAnnocement(this.model.annoucementId)
      .then(response => {
        if (response) {
          this.annoucementTitle = response.title;
        }
      });
  }
  sendProporsal() {
    let model = {
      userId: this.user.id,
      sendMail: this.Status
    };
    this.saving = true;
    this.model.enviada = true;
    this.model.sendDateToIES = new Date();
    new BaseHttpClient("Porposal")
      .putAsync<any>("send", this.model.id, model)
      .then((result: any) => {
        this.$buefy.toast.open({
          message: "La propuesta se ha enviado exitosamente!",
          duration: 9000,
          queue: false,
          type: "is-success",
          position: "is-top-right"
        });
        this.$router.push(
          `/convocatoria/propuesta/` + this.model.id + `/detail`
        );
      })
      .catch((err: any) => {
        this.$buefy.toast.open({
          message: "Ha ocurrido un error, favor intentarlo nuevamente!",
          duration: 4000,
          queue: false,
          type: "is-danger"
        });
        console.log(err);
      })
      .finally(() => {
        this.saving = false;
      });
  }
  protected async getData() {
    try {
      this.loading = true;
      let response = await this.repository.byId(this.id, this.include);
      if (response.startDate) response.startDate = new Date(response.startDate);
      if (response.endDate) response.endDate = new Date(response.endDate);

      this.model = response;
      this.annoucementId = this.model.annoucementId as number;
      this.modelInit = this.map<Porposal>(this.model);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }
  onRemoveDoc(doc: Document) {
    if (this.model.proposalDocuments) {
      this.model.proposalDocuments.map(x => {
        if (doc.id && x.documentId === doc.id) {
          x.deleted = true;
          x.document = null;
        }
        return x;
      });
      if (!doc.id) {
        let index = this.model.proposalDocuments.findIndex(x =>
          this.equals(x.document, doc)
        );
        if (index >= 0) {
          this.model.proposalDocuments.splice(index, 1);
        }
      }
    }
  }
  get documentsSelected() {
    if (this.model && this.model.proposalDocuments)
      return this.model.proposalDocuments.map(x => x.document);
    return [];
  }

  public wordCounter(event: any) {
    if (event.keyCode === 32) {
      if (this.model.executiveSummary) {
        this.words = this.model.executiveSummary.split(" ");
        this.counter = this.words.length;
      }
    } else if (event.keyCode === 8) {
      if (this.model.executiveSummary) {
        this.words = this.model.executiveSummary.split(" ");
        this.counter = this.words.length;
      }
    }
  }
  get totalInMounth() {
    let startDate = this.model.startDate as any;
    let endDate = this.model.endDate as any;
    this.model.periodMonth = Math.abs(moment(startDate).diff(endDate, "M"));
    var years = Math.ceil(this.model.periodMonth / 12);
    this.years = [];
    for (let i = 1; i <= years; i++) {
      this.years.push(i);
    }
    return this.model.periodMonth;
  }
  public getCoins() {
    this.CoinService.getCoins().then(response => {
      if (response) {
        this.Coins = response;
        this.model.coinId = response[0].id;
      }
    });
  }

  editorOption = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
        ["link", "image", "video"]
      ],
      imageDrop: true
    },
    placeholder: "Escriba el contenido aqui..."
  };

  get user() {
    return this.$store.state.user;
  }

  mounted() {
    var member = new ProposalMember();
    member.hasUser = true;
    member.userId = this.user.id;
    this.model.porposalMembers.push(member);
  }
  created() {
    this.getMemberTypes();
    this.getProjectTypes();
    this.getCoins();
    this.getBudgetExpenses();
    //this.getcenterByInvestigatorId();
  }

  addMember() {
    this.model.porposalMembers.push(new ProposalMember());
  }
  public getcenterByInvestigatorId() {
    if (this.userService) {
      this.userService
        .researchCenterByInvestigator(this.user.id)
        .then(center => {
          this.researchCenters = center;
        });
    }
  }

  removeMember(row: any) {
    this.model.porposalMembers = this.model.porposalMembers.filter(
      (x: any) => x != row
    );
  }

  getMemberTypes() {
    this.memberTypeService.getAll().then((list: any) => {
      this.memberTypes = list;
    });
  }
  getProjectTypes() {
    this.projectTypeService.getAll().then((list: any) => {
      this.projectTypes = list;
    });
  }

  public addConsortium() {
    this.model.proposedConsortiums.push(new ProposedConsortium());
  }

  public removeConsortium(row: any) {
    this.model.proposedConsortiums = this.model.proposedConsortiums.filter(
      (x: any) => x != row
    );
  }

  deleteDropFile(index: any) {
    this.dropFiles.splice(index, 1);
  }
  formatDocs() {
    if (this.model.proposalDocuments) {
      this.model.proposalDocuments = this.model.proposalDocuments.map(x => {
        if (x.documentId) delete x.document;
        return x;
      });
    }
  }

    cleanObj(sendObject: Porposal) {
    sendObject.porposalBudgetItems = sendObject.porposalBudgetItems.map(x => {
      x.budgetItem = null;
      return x;
    });
    sendObject.coin = null;
    sendObject.researchCenter = null;
    sendObject.area = null;
    sendObject.fieldArea = null;
    sendObject.researchLine = null;
  }
  protected async edit() {
    try {
      this.saving = true;
      this.formatDocs();
      var sendObject = Utils.mapToObject(
        this.model,
        new Porposal()
      ) as Porposal;

      sendObject.porposalBudgetItems = sendObject.porposalBudgetItems.map(x => {
        x.budgetItem = null;
        x.porposalBudgetSubItems = x.porposalBudgetSubItems.map(y => {
          y.budgetSubItem = null;
          return y;
        });
        x.porposalBudgetSubItems = x.porposalBudgetSubItems.filter(
          y => !y.isNewButton
        );
        return x;
      });
      sendObject.coin = null;
      sendObject.researchCenter = null;

      var result = await this.repository.update(this.id, sendObject);
      this.saving = false;
      this.$emit("edit", result);
      this.operationSuccess();
    } catch (error) {
      var errors: any[] = [];
      if (Object.prototype.toString.call(error.data) === "[object String]") {
        errors.push(error.data);
      } else if (error.data && error.data.length > 0) {
        var errorMessages = error.data as any[];
        errorMessages.forEach(x => errors.push(x.errorMessage));
      } else {
        errors.push(error);
      }
      console.log(errors);
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }

  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then(response => {
      if (response) {
        this.budgetExpenses = response;
      }
    });
  }

  calculateProposalBudgetItemByYear(porposalBudgetItem: PorposalBudgetItem) {
    var budgets = porposalBudgetItem.porposalBudgetItemInstitutions.filter(
      x => x.yearNumber == porposalBudgetItem.currentYear
    );
    return budgets.reduce((a, b) => {
      var amount = b.amount ? parseFloat(b.amount as any) : 0;
      return a + amount;
    }, 0);
  }

  calculatePorposalBudgetItem(porposalBudgetItem: PorposalBudgetItem) {
    if (
      porposalBudgetItem.budgetItem &&
      porposalBudgetItem.budgetItem.budgetItemCalculation ==
        BudgetItemCalculation.UNIDADXMESESXCOSTOUNITARIO
    ) {
      var total =
        (porposalBudgetItem.unit || 0) *
        (porposalBudgetItem.unitCost || 0) *
        (porposalBudgetItem.month || 0);
      return total == 0 ? "Costo total" : total;
    } else {
      var total =
        (porposalBudgetItem.unit || 0) * (porposalBudgetItem.unitCost || 0);
      return total == 0 ? "Costo total" : total;
    }
  }

  get canConfigureBudget() {
    return (
      this.model.startDate &&
      this.model.endDate &&
      this.model.coinId &&
      this.model.researchCenterId
    );
  }
  get institutionBudgetByYear() {
    var institutionBudgetByYear = [];
    if (!this.model.porposalBudgetItems.length) {
      return true;
    }
    for (let z = 0; z < this.years.length; z++) {
      const year = this.years[z];
      var resume = {
        year: 0,
        FONDOCYT: 0,
        institutionalAport: 0,
        othersInstitutions: 0
      };
      for (let i = 0; i < this.model.porposalBudgetItems.length; i++) {
        const budgetItem = this.model.porposalBudgetItems[i];

        var budgetInstitutions = budgetItem.porposalBudgetItemInstitutions.filter(
          x => x.yearNumber == year
        );

        resume.year = year;

        for (let y = 0; y < budgetInstitutions.length; y++) {
          const budgetInstitution = budgetInstitutions[y];
          var amount = budgetInstitution.amount as any;
          if (budgetInstitution.isFondocyt) {
            resume.FONDOCYT += amount;
          } else if (budgetInstitution.researchCenterId) {
            resume.institutionalAport += amount;
          } else {
            resume.othersInstitutions += amount;
          }
        }
      }
      institutionBudgetByYear.push(resume);
    }
    return institutionBudgetByYear;
  }
  get totalBudget() {
    var totalBudgetGeneral = 0;
    this.totalBudgetFondocyt = 0;
    this.totalBudgetInstitutionalAport = 0;
    for (let i = 0; i < this.model.porposalBudgetItems.length; i++) {
      const budgetItem = this.model.porposalBudgetItems[i];
      for (
        let y = 0;
        y < budgetItem.porposalBudgetItemInstitutions.length;
        y++
      ) {
        const budgetItemInstitution =
          budgetItem.porposalBudgetItemInstitutions[y];
        const amount = budgetItemInstitution.amount as any | 0;
        if (budgetItemInstitution.researchCenterId) {
          this.totalBudgetInstitutionalAport += amount;
        } else if (budgetItemInstitution.isFondocyt) {
          this.totalBudgetFondocyt += amount;
        }
        totalBudgetGeneral += amount;
      }
    }
    return totalBudgetGeneral;
  }
}
